import { ITrayline, IDeliveryException } from '../../models/service/checkpoints-settings.model';
import { IActiveTray } from '../../models/service/active-trays.model';
import { ITrayCheckpoints } from 'src/app/models/checkpoints/checkpoint-utilities.model';

export class AddCheckpointsSettings {
    static readonly type = '[Checkpoints] AddCheckpointsSettings]';
    constructor(public readonly payload: ITrayline[]) {}
}
export class AddActiveTrays {
    static readonly type = '[Checkpoints] AddActiveTrays]';
    constructor(public readonly payload: IActiveTray[]) {}
}
export class AddExceptionList {
    static readonly type = '[Checkpoints] AddExceptionList]';
    constructor(public readonly payload: IDeliveryException[]){}
}
export class UpdateTrays {
    static readonly type = '[Checkpoints] UpdateTray]';
    constructor(public readonly payload: {trays: ITrayCheckpoints[], trayLineOid: number}) {}
}

export class DeleteTrays {
    static readonly type = '[Checkpoints] DeleteTray]';
    constructor(public readonly payload: {trays: ITrayCheckpoints[], trayLineOid: number}) {}
}

